import { InjectionToken } from '@angular/core';

export interface TourConfig {
  /** localStorage key prefix for completed tours. */
  storageKey?: string;
  /** Overlay z-index (above dialogs default 50). */
  zIndex?: number;
  /** Spotlight padding around the target element (px). */
  spotlightPadding?: number;
  /** Backdrop darkness 0–1. */
  backdropOpacity?: number;
}

export const TOUR_CONFIG = new InjectionToken<TourConfig>('TOUR_CONFIG', {
  factory: () => ({
    storageKey: 'tc_tour_completed',
    zIndex: 10100,
    spotlightPadding: 8,
    backdropOpacity: 0.72,
  }),
});
